export enum IconEnum {
    ADVICE = 'advice',
    ARTICLE = 'article',
    ATTACHEMENT = 'attachement',
    BURGER = 'burger',
    CALENDAR = 'calendar',
    CHECKBOX = 'checkbox',
    CHEVRON = 'chevron',
    CHEVRON_DOWN = 'chevronDown',
    CHEVRON_LEFT = 'chevronLeft',
    CHEVRON_RIGHT = 'chevronRight',
    CHEVRON_UNCONSTRAINED = 'chevronUnconstrained',
    CHEVRON_UP = 'chevronUp',
    CLOSE = 'close',
    DISCOVER = 'discover',
    DOWN = 'down',
    DOWNLOAD = 'download',
    EXCEL = 'excel',
    EXCITED = 'excited',
    FLAG = 'flag',
    HEART = 'heart',
    HOME = 'home',
    INTERVIEW = 'interview',
    INVOLVED = 'involved',
    LEFT = 'left',
    LIVE = 'live',
    LOGOUT = 'logout',
    LOGO_SIMPLIFIED = 'logoSimplified',
    LOGO_SIMPLIFIED_DARK = 'logoSimplifiedDark',
    MAG = 'mag',
    NEXT = 'next',
    PEN = 'pen',
    PIN = 'pin',
    QUOTE = 'quote',
    RACE = 'race',
    RACE_FLAG = 'raceFlag',
    RANDOM = 'random',
    REFUELING_STAND = 'refuelingStand',
    RIGHT = 'right',
    RUNNER = 'runner',
    RUNNING_STONES = 'runningStones',
    SEARCH = 'search',
    SHARE = 'share',
    SHOP = 'shop',
    SMILEY_LAUGH = 'smileyLaugh',
    SMILEY_SHY = 'smileyShy',
    SMILEY_SURPRISED = 'smileySurprised',
    SOCIAL_DAILYMOTION = 'dailymotion',
    SOCIAL_FACEBOOK = 'facebook',
    SOCIAL_INSTAGRAM = 'instagram',
    SOCIAL_LINKEDIN = 'linkedin',
    SOCIAL_STRAVA = 'strava',
    SOCIAL_TIKTOK = 'tiktok',
    SOCIAL_TWITTER = 'twitter',
    SOCIAL_WECHAT = 'wechat',
    SOCIAL_X = 'socialX',
    SOCIAL_YOUTUBE = 'youtube',
    SPINNER = 'spinner',
    STAR = 'star',
    STAR_BORDER = 'starBorder',
    STONE_EVENTS = 'stone_events',
    STONE_MAJORS = 'stone_majors',
    THUMB_UP = 'thumbUp',
    TRAIN = 'train',
    TUNNEL = 'tunnel',
    UP = 'up',
    USER = 'user',
    UTMB_GROUP = 'utmbGroup',
    UTMB_RUNNER = 'utmbRunner',
}
